import DataFetcherTemplate from "../hooks/fetchTemplate";

 
import { NavLink } from "react-router-dom";
import Breadcumbs from "../components/Breadcumbs";
 
import Block2ColumnsText from "../components/Block2ColumnsText";
 
import BlockRightImage from "../components/BlockRightImage";
import BlockLeftImage from "../components/BlockLeftImage";
import FixedHeader from "../components/FixedHeader";
import Quote from "../components/Quote";
import ConectUs from "../components/ConectUs";
 
import { motion } from "framer-motion";
import MasonryGallery from "../components/MasonryGallery";
import Notification from "../components/Notification";
function CarismaIdente() {
  const DataDisplay = ({ data }) => (
    <>
      <>
        {data.map((item, index) => (
          <>
            <FixedHeader
              src={item.field_portada}
              video={item.field_video_portada}
              span0={<> "Sentar a Cristo </>}
              span1="en las diferentes"
              span3={<>cátedras del mundo"</>}
              span5="Fernando Rielo"
            ></FixedHeader>
            <div className="bluebg">
              <Breadcumbs
                content={
                  <>
                    <NavLink to="/carisma-idente">Carisma Idente</NavLink>
                  </>
                }
              ></Breadcumbs>
              <center>
                {" "}
                <motion.div
                  className="span0"
                  initial={{ y: 150, opacity: 0 }}
                  whileInView={{
                    y: 0,
                    opacity: 1,
                    transition: {
                      type: "spring",
                      stiffness: 200,
                    },
                  }}
                >
                  <div
                    className="layout6 fontsize14"
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque1,
                    }}
                  />
                </motion.div>
              </center>
              <br></br> <br></br>
              <div>
                <MasonryGallery gallery={item.field_gallery1}></MasonryGallery>
              </div>
            </div>

            <div>
              <BlockRightImage
                src={item.field_imagen2}
                content={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque2,
                      }}
                    />
                  </>
                }
              ></BlockRightImage>

              <BlockLeftImage
                src={item.field_imagen3}
                content={
                  <>
                    <Quote
                      autor="Fernando Rielo"
                      content={
                        <>
                          {" "}
                          <p>
                            {" "}
                            El joven es más ilusión que pensamiento, por eso
                            necesita, más que amigos un maestro.
                          </p>
                        </>
                      }
                    ></Quote>

                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque3,
                      }}
                    />
                  </>
                }
              ></BlockLeftImage>
              <div className=" bluebg">
                <BlockRightImage
                  src={item.field_imagen4}
                  content={
                    <>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque4,
                        }}
                      />
                    </>
                  }
                ></BlockRightImage>
                <Block2ColumnsText
                  col1={
                    <>
                      <div className="width100">
                        <img src={item.field_imagen5}></img>
                      </div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque5,
                        }}
                      />
                    </>
                  }
                  col2={
                    <>
                      <div className="width100">
                        <img src={item.field_imagen6}></img>
                      </div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque6,
                        }}
                      />
                    </>
                  }
                ></Block2ColumnsText>
                <br></br> <br></br> <br></br>
              </div>

              <motion.div
                className="lightbluebg"
                initial={{ y: 150, opacity: 0 }}
                whileInView={{
                  y: 0,
                  opacity: 1,
                  transition: {
                    type: "spring",
                    stiffness: 200,
                  },
                }}
              >
                <div className=" layout6 padding">
                  {" "}
                  <center>
                    <p className="iconsize20">✨ </p>
                    <div
                      className="fontsize14"
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque7,
                      }}
                    />
                  </center>
                </div>
              </motion.div>
            </div>
            <div className="redes-carisma-idente padding">
              <ConectUs
                lema={
                  <>
                    <center>
                      {" "}
                      <h3>Sigue las actividades y noticias de:</h3>
                    </center>
                    <h4>Identes Ecuador</h4>
                  </>
                }
                instagram="https://www.instagram.com/identesecuador/"
                facebook="https://www.facebook.com/identesecuador"
              ></ConectUs>
              <div className="instituto">
                <ConectUs
                  lema={
                    <>
                      <h4>
                        Instituto Id de Cristo redentor misioneras y misioneros
                        identes
                      </h4>
                    </>
                  }
                  instagram="https://www.instagram.com/misionerosidentes/"
                  facebook="https://www.facebook.com/Misionerosidentes"
                  youtube="https://www.youtube.com/@MisionerasyMisionerosIdentes"
                ></ConectUs>
              </div>
            </div>
            <div>
              <Notification
                content={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque8,
                      }}
                    />
                  </>
                }
              ></Notification>
            </div>
          </>
        ))}
      </>
    </>
  );
  return (
    <>
      {" "}
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/services/carisma-idente.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>
    </>
  );
}

export default CarismaIdente;
